// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"b76e84f3","481":"57475498","708":"e5185dc2","754":"97ca4962"}[chunkId] + ".chunk.css";
};